import { render } from "./CustomReminders.vue?vue&type=template&id=72411a68&scoped=true"
import script from "./CustomReminders.vue?vue&type=script&lang=js"
export * from "./CustomReminders.vue?vue&type=script&lang=js"

import "./CustomReminders.vue?vue&type=style&index=0&id=72411a68&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72411a68"]])

export default __exports__